export default "https://cdn-static.gokick.com/assets/eeaee1442152ca0221916151b947444cbee5198d/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";